import controller from './kform-tab-opentext.controller';
import template from './kform-tab-opentext.html';
import './kform-tab-opentext.scss';

export default {
	controller,
	template,
	bindings: {
		form:     '<?',
		file:     '<?',
		kid:      '<',
		disabled: '<?ngDisabled',
		onLoad:   '&?',
	},
	require: {
		content: '^^?kformContent',
		kform:   '^^?kform',
	},
};
